import './logout-state.scss';
import ADDLogo from '@svg/dd-logo.svg?react';
import CustomButton from '../shared/custom-button/custom-button';
import { useNavigate } from 'src/utils/use-navigate';
export const LogoutState = () => {

    const navigate = useNavigate();
    return (
        <div className="logout-container">
            <div className="dd-logo"><ADDLogo /></div>
            <div className={'message'}>
                <div className={'title'}>Looks like you stepped away</div>
                <div className={'sub-title'}>To keep your information safe, we’ve ended your session</div>
            </div>
            <CustomButton label={'Back to Dynamic Defense'} className={'primary-btn'} onClick={() => navigate('/', {replace: true})}/>
        </div>
    );
};